import {
  GET_SALESORDER_REQUEST,
  GET_SALESORDER_SUCCESS,
  GET_SALESORDER_FAILURE,
  GET_SALESORDER_FOR_AFS_REQUEST,
  GET_SALESORDER_FOR_AFS_SUCCESS,
  GET_SALESORDER_FOR_AFS_FAILURE,
  GET_VINSBYTRIPNO_REQUEST,
  GET_VINSBYTRIPNO_SUCCESS,
  GET_VINSBYTRIPNO_FAILURE,
  PUT_APPROVEVIN_REQUEST,
  PUT_APPROVEVIN_SUCCESS,
  PUT_APPROVEVIN_FAILURE,
  GET_ACCESSORIESBYVIN_REQUEST,
  GET_ACCESSORIESBYVIN_SUCCESS,
  GET_ACCESSORIESBYVIN_FAILURE,
  UPDATE_RELEASE_TRIP_REQUEST,
  UPDATE_RELEASE_TRIP_SUCCESS,
  UPDATE_RELEASE_TRIP_FAILURE,
  UPDATE_VIN_REQUEST,
  UPDATE_VIN_SUCCESS,
  UPDATE_VIN_FAILURE,
  CREATE_DISPATCH_REQUEST,
  CREATE_DISPATCH_SUCCESS,
  CREATE_DISPATCH_FAILURE,
  GET_FG_CODE_REQUEST,
  GET_FG_CODE_SUCCESS,
  GET_FG_CODE_FAILURE,
  GET_FG_CODE_NO_PAGINATION_REQUEST,
  GET_FG_CODE_NO_PAGINATION_SUCCESS,
  GET_FG_CODE_NO_PAGINATION_FAILURE,
  GET_VINBYFGCODE_FOR_DISPATCH_REQUEST,
  GET_VINBYFGCODE_FOR_DISPATCH_SUCCESS,
  GET_VINBYFGCODE_FOR_DISPATCH_FAILURE,
  CREATE_SALESORDER_DISPATCH_REQUEST,
  CREATE_SALESORDER_DISPATCH_SUCCESS,
  CREATE_SALESORDER_DISPATCH_FAILURE,
  CREATE_REPRINT_DISPATCH_REQUEST,
  CREATE_REPRINT_DISPATCH_SUCCESS,
  CREATE_REPRINT_DISPATCH_FAILURE,
} from "./dispatchTypes";
import axios from "axios";
import Config from "../../config/index";

let baseUrl = Config.baseUrl;

const getSalesOrderRequest = () => {
  return {
    type: GET_SALESORDER_REQUEST,
  };
};

const getSalesOrderSuccess = (payload) => {
  return {
    type: GET_SALESORDER_SUCCESS,
    payload: payload,
  };
};

const getSalesOrderFailure = (error) => {
  return {
    type: GET_SALESORDER_FAILURE,
    payload: error,
  };
};

const getSalesOrder = (status, pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSalesOrderRequest());
    let url = `${baseUrl}/dispatch/get_sales_orders?itemTypeId=1&status=${status}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSalesOrderSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSalesOrderFailure(err.message));
      });
  };
};

const getSalesOrderForAFSRequest = () => {
  return {
    type: GET_SALESORDER_FOR_AFS_REQUEST,
  };
};

const getSalesOrderForAFSSuccess = (payload) => {
  return {
    type: GET_SALESORDER_FOR_AFS_SUCCESS,
    payload: payload,
  };
};

const getSalesOrderForAFSFailure = (error) => {
  return {
    type: GET_SALESORDER_FOR_AFS_FAILURE,
    payload: error,
  };
};

const getSalesOrderForAFS = (status, pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSalesOrderForAFSRequest());
    let url = `${baseUrl}/afs_dispatch/get_sales_orders?itemTypeId=5&status=${status}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSalesOrderForAFSSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSalesOrderForAFSFailure(err.message));
      });
  };
};
const getFgCodeRequest = () => {
  return {
    type: GET_FG_CODE_REQUEST,
  };
};

const getFgCodeSuccess = (payload) => {
  return {
    type: GET_FG_CODE_SUCCESS,
    payload: payload,
  };
};

const getFgCodeFailure = (error) => {
  return {
    type: GET_FG_CODE_FAILURE,
    payload: error,
  };
};

const getFgCode = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgCodeRequest());
    let url = `${baseUrl}/model/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgCodeSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFgCodeFailure(err.message));
      });
  };
};

const getFgCodeNoPaginationRequest = () => ({
  type: GET_FG_CODE_NO_PAGINATION_REQUEST,
});

const getFgCodeNoPaginationSuccess = (payload) => ({
  type: GET_FG_CODE_NO_PAGINATION_SUCCESS,
  payload: payload,
});

const getFgCodeNoPaginationFailure = (error) => ({
  type: GET_FG_CODE_NO_PAGINATION_FAILURE,
  payload: error,
});


const getFgCodeNoPagination = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgCodeNoPaginationRequest());
    let url = `${baseUrl}/model/get_all_without_pagination`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgCodeNoPaginationSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFgCodeNoPaginationFailure(err.message));
      });
  };
};

const approveVinRequest = () => {
  return {
    type: PUT_APPROVEVIN_REQUEST,
  };
};

const approveVinSuccess = (payload) => {
  return {
    type: PUT_APPROVEVIN_SUCCESS,
    payload: payload,
  };
};

const approveVinFailure = (error) => {
  return {
    type: PUT_APPROVEVIN_FAILURE,
    payload: error,
  };
};

const approveVin = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(approveVinRequest());
    let url = `${baseUrl}/dispatch/accept_vin`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(approveVinSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(approveVinFailure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const getVinStatusByTripNoRequest = () => {
  return {
    type: GET_VINSBYTRIPNO_REQUEST,
  };
};

const getVinStatusByTripNoSuccess = (payload) => {
  return {
    type: GET_VINSBYTRIPNO_SUCCESS,
    payload: payload,
  };
};

const getVinStatusByTripNoFailure = (error) => {
  return {
    type: GET_VINSBYTRIPNO_FAILURE,
    payload: error,
  };
};

const getVinStatusByTripNo = (salesOrderNumber, tripNo, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVinStatusByTripNoRequest());
    let url = `${baseUrl}/dispatch/get_vin_by_sales_order?salesOrderNumber=${salesOrderNumber}&tripNo=${tripNo}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVinStatusByTripNoSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVinStatusByTripNoFailure(err.message));
      });
  };
};

const getAccessoriesByVinRequest = () => {
  return {
    type: GET_ACCESSORIESBYVIN_REQUEST,
  };
};

const getAccessoriesByVinSuccess = (payload) => {
  return {
    type: GET_ACCESSORIESBYVIN_SUCCESS,
    payload: payload,
  };
};

const getAccessoriesByVinFailure = (error) => {
  return {
    type: GET_ACCESSORIESBYVIN_FAILURE,
    payload: error,
  };
};

const getAccessoriesByVin = (vin, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAccessoriesByVinRequest());
    let url = `${baseUrl}/`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAccessoriesByVinSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getAccessoriesByVinFailure(err.message));
      });
  };
};

const releaseTripRequest = () => {
  return {
    type: UPDATE_RELEASE_TRIP_REQUEST,
  };
};

const releaseTripSuccess = (payload) => {
  return {
    type: UPDATE_RELEASE_TRIP_SUCCESS,
    payload: payload,
  };
};

const releaseTripFaliure = (error) => {
  return {
    type: UPDATE_RELEASE_TRIP_FAILURE,
    payload: error,
  };
};

const releaseTrip = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(releaseTripRequest());
    let url = `${baseUrl}/dispatch/release_sales_order`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(releaseTripSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(releaseTripFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const changeVinRequest = () => {
  return {
    type: UPDATE_VIN_REQUEST,
  };
};

const changeVinSuccess = (payload) => {
  return {
    type: UPDATE_VIN_SUCCESS,
    payload: payload,
  };
};

const changeVinFaliure = (error) => {
  return {
    type: UPDATE_VIN_FAILURE,
    payload: error,
  };
};

const changeVin = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(changeVinRequest());
    let url = `${baseUrl}/dispatch/replace_vin`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(changeVinSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(changeVinFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createDispatchRequest = () => {
  return {
    type: CREATE_DISPATCH_REQUEST,
  };
};

const createDispatchSuccess = (payload) => {
  return {
    type: CREATE_DISPATCH_SUCCESS,
    payload: payload,
  };
};

const createDispatchFailure = (error) => {
  return {
    type: CREATE_DISPATCH_FAILURE,
    payload: error,
  };
};

const createDispatch = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createDispatchRequest());
    let url = `${baseUrl}/dispatch/trip`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createDispatchSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createDispatchFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const reprintDispatchRequest = () => {
  return {
    type: CREATE_REPRINT_DISPATCH_REQUEST,
  };
};

const reprintDispatchSuccess = (payload) => {
  return {
    type: CREATE_REPRINT_DISPATCH_SUCCESS,
    payload: payload,
  };
};

const reprintDispatchFailure = (error) => {
  return {
    type: CREATE_REPRINT_DISPATCH_FAILURE,
    payload: error,
  };
};

const reprintDispatch = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(reprintDispatchRequest());
    let url = `${baseUrl}/afs_dispatch/reprint_bin`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(reprintDispatchSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reprintDispatchFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const afsDispatchSalesOrderRequest = () => {
  return {
    type: CREATE_SALESORDER_DISPATCH_REQUEST,
  };
};

const afsDispatchSalesOrderSuccess = (payload) => {
  return {
    type: CREATE_SALESORDER_DISPATCH_SUCCESS,
    payload: payload,
  };
};

const afsDispatchSalesOrderFailure = (error) => {
  return {
    type: CREATE_SALESORDER_DISPATCH_FAILURE,
    payload: error,
  };
};

const afsDispatchSalesOrder = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(afsDispatchSalesOrderRequest());
    let url = `${baseUrl}/afs_dispatch/create_bins`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(afsDispatchSalesOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(afsDispatchSalesOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const getVinByFgcodeForDispatchRequest = () => {
  return {
    type: GET_VINBYFGCODE_FOR_DISPATCH_REQUEST,
  };
};

const getVinByFgcodeForDispatchSuccess = (payload) => {
  return {
    type: GET_VINBYFGCODE_FOR_DISPATCH_SUCCESS,
    payload: payload,
  };
};

const getVinByFgcodeForDispatchFailure = (error) => {
  return {
    type: GET_VINBYFGCODE_FOR_DISPATCH_FAILURE,
    payload: error,
  };
};

const getVinByFgCodeForDispatch = (fgCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVinByFgcodeForDispatchRequest());
    let url = `${baseUrl}/dispatch/get_newvin=${fgCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVinByFgcodeForDispatchSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getVinByFgcodeForDispatchFailure(err.message));
      });
  };
};

export {
  getSalesOrder,
  getSalesOrderForAFS,
  approveVin,
  getVinStatusByTripNo,
  getAccessoriesByVin,
  releaseTrip,
  changeVin,
  createDispatch,
  getFgCode,
  getFgCodeNoPagination,
  getVinByFgCodeForDispatch,
  afsDispatchSalesOrder,
  reprintDispatch,
};
